import { Link as RemixLink, type LinkProps as RemixLinkProps } from '@remix-run/react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '#app/utils/misc'

const baseButtonStyles =
  'inline-flex items-center justify-center h-10 px-4 py-2 rounded-md text-body-sm font-medium focusable transition-colors outline-none disabled:opacity-50 cursor-pointer disabled:cursor-not-allowed'

const linkVariants = cva('', {
  variants: {
    variant: {
      default: 'text-gray-12 hover:cursor-pointer hover:text-accent-11 hover:underline',
      button: `${baseButtonStyles} bg-accent-9 hover:bg-accent-10 text-gray-1 dark:text-gray-12`,
      buttonSecondary: `${baseButtonStyles} border bg-accent-3 hover:bg-accent-4 text-accent-11 border-accent-7 hover:border-accent-8`,
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

export interface LinkProps extends RemixLinkProps, VariantProps<typeof linkVariants> {}

export const Link = ({ className, children, variant, ...props }: LinkProps) => (
  <RemixLink className={cn(linkVariants({ variant, className }))} {...props}>
    {children}
  </RemixLink>
)
Link.displayName = 'Link'
